














































































































































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import { Household } from "@/models/app-data";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { HouseholdInformationContent } from "@/models/content/household-information";

@Component({
  components: {
    FooterButton,
  },
})
export default class HouseholdInformation extends Mixins(CommonMixin) {
  content = {} as HouseholdInformationContent;
  PercentDone = 80;
  fullTimeChecked = false;
  partTimeChecked = false;
  schoolChecked = false;
  schoolFullTimeChecked = false;
  unemployedChecked = false;
  retiredChecked = false;
  disabilityBenefitsChecked = false;
  unemploymentBenefitsChecked = false;
  ssiChecked = false;
  tanfChecked = false;
  mdhhsChecked = false;
  noneChecked = false;
  appData!: AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getHouseholdInformationContent();
      this.textDirection = contentService.TextDirection();

      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }

      this.appData = this.getAppData();

      if (this.appData != null && this.appData.household != null) {
        this.fullTimeChecked = this.appData.household.fullTime;
        this.partTimeChecked = this.appData.household.partTime;
        this.schoolChecked = this.appData.household.attendingSchool;
        this.schoolFullTimeChecked = this.appData.household.attendingSchoolFullTime;
        this.unemployedChecked = this.appData.household.unemployed;
        this.retiredChecked = this.appData.household.retired;
        this.disabilityBenefitsChecked = this.appData.household.disabilityBenefits;
        this.unemploymentBenefitsChecked = this.appData.household.unemploymentBenefits;
        this.ssiChecked = this.appData.household.ssiBenefits;
        this.tanfChecked = this.appData.household.tanfBenefits;
        this.mdhhsChecked = this.appData.household.mdhhs;
        this.noneChecked = this.appData.household.noBenefits;
      }
      this.putWorkflowStep( this.appData?.workflowId, "HouseholdInformation") 
    } catch (error) {
      this.showError(error);
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.fullTimeChecked = false;
      this.partTimeChecked = false;
      this.schoolChecked = false;
      this.schoolFullTimeChecked = false;
      this.unemployedChecked = false;
      this.retiredChecked = false;
      this.disabilityBenefitsChecked = false;
      this.unemploymentBenefitsChecked = false;
      this.ssiChecked = false;
      this.tanfChecked = false;
      this.mdhhsChecked = false;
    }
  }

  disableNext(): boolean {
    return !(
      this.fullTimeChecked ||
      this.partTimeChecked ||
      this.schoolChecked ||
      this.schoolFullTimeChecked ||
      this.unemployedChecked ||
      this.retiredChecked ||
      this.disabilityBenefitsChecked ||
      this.unemploymentBenefitsChecked ||
      this.ssiChecked ||
      this.tanfChecked ||
      this.mdhhsChecked ||
      this.noneChecked
    );
  }
  public handleNextPageEvent(): void {
    this.saveData();
    this.$router.push({ path: "FinalDetails" });
  }

  saveData(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    if (this.appData.household == null) {
      this.appData.household = {} as Household;
    }
    this.appData.household.fullTime = this.fullTimeChecked;
    this.appData.household.partTime = this.partTimeChecked;
    this.appData.household.attendingSchool = this.schoolChecked;
    this.appData.household.attendingSchoolFullTime = this.schoolFullTimeChecked;
    this.appData.household.unemployed = this.unemployedChecked;
    this.appData.household.retired = this.retiredChecked;
    this.appData.household.disabilityBenefits = this.disabilityBenefitsChecked;
    this.appData.household.unemploymentBenefits = this.unemploymentBenefitsChecked;
    this.appData.household.ssiBenefits = this.ssiChecked;
    this.appData.household.tanfBenefits = this.tanfChecked;
    this.appData.household.mdhhs = this.mdhhsChecked;
    this.appData.household.noBenefits = this.noneChecked;

    this.saveAppData(this.appData);
  }
}
